import './HostSection.css';
import React, { useState, useEffect }  from "react"
import {Link} from "react-router-dom"
import { Container, Row, Button, Spinner} from 'react-bootstrap';
import axios from "axios";
import HostSection from "./HostSection"

function HostInformationQuery(setIsLoaded) {

    const [hosts, setHosts] = useState([]);

    const source = axios.CancelToken.source();

    const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT;
    const requestPath = REACT_APP_ENDPOINT + "/hosts"

    const getHosts = () => {
    axios.get(requestPath , { cancelToken: source.token }).then((res) => {
      setHosts(res.data);
      source.cancel();
      setIsLoaded(true);
      });
    };

    // Note:  The below useEffect produces development compiler warning. Okay to ignore.

    useEffect(() => {
        getHosts();
     }, []);
    return (hosts)
    // return []
}

function createHost (host) {

    return (
        <HostSection
            key = {host.user_id}
            userId = {host.user_id}
            firstName = {host.first_name}
            lastName = {host.last_name}
            availableToPublic = {host.available_to_public}
            photoLink = {host.photo_link}
            headline = {host.headline}
            hostMessage = {host.host_message}
            resumeLink = {host.resume_link}
            averageRating = {host.average_rating}
            hostedGameCount = {host.hosted_game_count}
            hostTimezone = {host.host_timezone}
            emailId = {host.email_id}
            phoneNumber = {host.phone_number}
            videoLink = {host.video_link}
            calendarLink = {host.calendar_link}
            paymentLink = {host.payment_link}
            />
    )
}

const HostSectionContainer = () => {

    // isLoaded is used for a spinner.  HostInformationQuery sets the status when done.
    const [isLoaded, setIsLoaded] = useState(false);

    const hosts = HostInformationQuery(setIsLoaded);

    return (

        <Container fluid  id="host-background">
            <Container fluid className="host-page-title-container">
            <div className="title-box" >
                <h1>  Meet Our Sponsored Game Hosts  </h1> <br></br>
                <h3>Book a pro for your next scheduled game.</h3>
                <h4>Let us do the work for you.</h4>
                <br></br>
                <Link to="/abouthostprocess" >
                    <Button variant="primary" className="yellow-button" >Learn More</Button>
                </Link>
                <br/>
                {(!isLoaded) &&
                <div> <br/> <br/>
                <Spinner animation="border"  role="status" style={{color: "#00603a"}}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                </div>
                }

            </div>
            </Container>
            <Container fluid className='d-flex justify-content-center' >
            <div>

                <Row xs={'auto'} md={'auto'} lg={'auto'} className='d-flex justify-content-center'>
                    {/* Only call map if data's been returned  */}
                    {(hosts.length > 0 && Array.isArray(hosts) ) && hosts.map(createHost)}
                </Row>
            </div>
            </Container>
        </Container>
    )
}

export default HostSectionContainer